"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagBN = function FlagBN(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.06,7.06,0,0,1-193,139.3V-114.94a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-193-114.94v42.37L216.6,96.93V47.49L-189.82-120.68a6.94,6.94,0,0,0-3.18,5.74Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-193-23.13,213.42,145a6.94,6.94,0,0,0,3.18-5.74V96.93L-193-72.57Zm0,0",
    transform: "translate(194 123)",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M51.47-.36v-.2s-.1-1-.27-2.78a25.1,25.1,0,0,0-.54-3.3A30.63,30.63,0,0,0,49.52-11,36.07,36.07,0,0,0,44-21.66c-.34-.45-.74-.9-1.11-1.35a40.11,40.11,0,0,0,4.63-6.54A42.46,42.46,0,0,1,30.4-33.13a41.9,41.9,0,0,0-9.8-3.67l-1.69-6.76A3.25,3.25,0,0,0,15.76-46H13.43v-3.25H24.79l-3.25-6.49,3.25-6.49H13.43V-65.5H10.18V-46H7.84a3.25,3.25,0,0,0-3.15,2.46L3-36.95a35.42,35.42,0,0,0-6.5,2,36.7,36.7,0,0,0-5,2.54,42.51,42.51,0,0,1-15.41,2.9A40.11,40.11,0,0,0-19.29-23c-.33.39-.69.74-1,1.15a41.29,41.29,0,0,0-5.33,10A44.46,44.46,0,0,0-27.87-.76V2.37a21.91,21.91,0,0,0,.18,2.92,41.12,41.12,0,0,0,1,5.82A42.82,42.82,0,0,0-22.21,22,40.38,40.38,0,0,0-5.09,37.53a40.57,40.57,0,0,0,11,3.34A40.73,40.73,0,0,0,11,41.4l.29,0h.14l.47,0,.68,0,1.35-.06c.89-.06,1.79,0,2.66-.18A39.25,39.25,0,0,0,35,34.09,40.16,40.16,0,0,0,46,21.81,41.44,41.44,0,0,0,50.5,10.15a32.23,32.23,0,0,0,.77-4.64,23.14,23.14,0,0,0,.21-3.35c0-1.64,0-2.52,0-2.52Zm-59,22.88a37.39,37.39,0,0,1-6.16-6.16A33.31,33.31,0,0,1-18,8.48,37,37,0,0,1-20-.36a36.62,36.62,0,0,1,.82-9.58,34.94,34.94,0,0,1,3.53-8.81c.09-.16.22-.3.31-.46C-7.92-13.44-.13-13.85,5.3-16.65v6.35c1.8,0,3.25,3.63,3.25,8.12S7.1,5.93,5.3,5.93V9.18c6.09,8.12,3.3,15-.44,19A32.43,32.43,0,0,1-.25,26.63a32.22,32.22,0,0,1-7.29-4.11ZM43.56-.73s-.09.89-.26,2.48a13.53,13.53,0,0,1-.47,2.66,23.34,23.34,0,0,1-.94,3.36,28.22,28.22,0,0,1-4.5,8.42,32.34,32.34,0,0,1-9.06,8,34.33,34.33,0,0,1-9.83,3.68c-3.61-4-6.16-10.74-.2-18.68V5.93c-1.8,0-3.25-3.63-3.25-8.11S16.5-10.3,18.3-10.3v-6.35c5.44,2.8,13.24,3.21,20.63-2.58.13.21.28.43.4.64a33.49,33.49,0,0,1,3.55,9.43,23.22,23.22,0,0,1,.55,3.64,18.53,18.53,0,0,1,.15,2.71c0,1.26,0,1.9,0,2.08Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.8,48.15a45.19,45.19,0,0,1-31-12.26,3.59,3.59,0,0,0-5.18.32L-36.79,50.72A2.37,2.37,0,0,0-35,54.64h7.82l10.43,5.22a3.25,3.25,0,0,0,4.15-1.11l3.36-5a55.08,55.08,0,0,0,21,4.17,55.12,55.12,0,0,0,21-4.17l3.36,5a3.25,3.25,0,0,0,4.15,1.11l10.43-5.22h7.82a2.38,2.38,0,0,0,1.8-3.92L48,36.21a3.59,3.59,0,0,0-5.18-.32,45.2,45.2,0,0,1-31,12.26Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-33.66,35.16H-49.9l3.25-29.23S-58,.25-56.82-16.43A3.9,3.9,0,0,1-52.93-20h2.77a3.9,3.9,0,0,1,3.84,3.27c.68,4.07,2.8,10.76,9.41,13Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M57.26,35.16H73.5L70.25,5.93S81.61.25,80.43-16.43A3.91,3.91,0,0,0,76.53-20H73.76a3.88,3.88,0,0,0-3.83,3.27c-.69,4.07-2.81,10.76-9.42,13Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-32,38.41H-51.52a1.63,1.63,0,0,1-1.62-1.63,1.63,1.63,0,0,1,1.62-1.62H-32a1.63,1.63,0,0,1,1.63,1.62A1.63,1.63,0,0,1-32,38.41Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M75.12,38.41H55.64a1.63,1.63,0,1,1,0-3.25H75.12a1.63,1.63,0,0,1,0,3.25Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagBN;
exports["default"] = _default;